


































import Vue from 'vue'
import productServices from '@/product/services'
import BaseImage from '@/common/components/BaseImage.vue'
import { RelatedCategory } from '@/product/types'
import { IMAGE_VARIANT_NAMES, SVG_PLACEHOLDER_IMAGES } from '@/common/constants'
export default Vue.extend({
  components: {
    BaseImage
  },
  props: {
    productId: {
      type: [Number, String],
      required: true
    }
  },
  data(): {
    categories: RelatedCategory[]
  } {
    return {
      categories: []
    }
  },
  computed: {
    IMAGE_VARIANT_NAMES() {
      return IMAGE_VARIANT_NAMES
    },
    imagePlaceHolder() {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  },
  async created() {
    const data = await productServices.getProductRelatedCategories(this.productId.toString())
    if (data) {
      this.categories = data.productRelatedCategories
    }
  }
})
